import Route from '@ember/routing/route';
import { set } from '@ember/object';
import { inject as iService } from '@ember/service';

export default class UserRoute extends Route {
  @iService session;

  model() {}

  async beforeModel(transition) {
    await super.beforeModel(transition);
    const controller = this.controllerFor('application');
    this.session.setAnonymous(true);
    await this.session.bootstrapSession(transition, controller);
  }

  setupController(controller, model) {
    super.setupController(controller, model);
    controller.checkHomeTask.perform();
    set(controller, 'showMenu', null);
    // Entering the route with the param already at its default never fires the
    // controller's `tab` setter, so the initial section is opened here.
    controller.applyTab(controller.tab);
  }

  resetController(controller) {
    controller.checkHomeTask.cancelAll();
  }
}
